import React from "react";
import { cardStyle } from "./ui";

// "Who holds what" for an Access screen: every permission set with how many people hold it, and a
// warning for the sets nobody holds yet (the owner and admins always work, but anyone else, and every
// approval routed to that set, has no one to go to).
//   permissions: [{ value, label }]    holders: { [permissionValue]: number }
export default function PermissionCoverage({ permissions, holders }) {
  if (!permissions || !permissions.length) return null;
  const missing = permissions.filter((p) => !holders[p.value]);
  return (
    <div style={{ ...cardStyle, padding: 12, marginBottom: 16 }}>
      <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 8 }}>Who holds each permission</div>
      <div className="d-flex flex-wrap gap-2">
        {permissions.map((p) => {
          const n = holders[p.value] || 0;
          return (
            <span
              key={p.value}
              style={{
                fontSize: 13,
                padding: "3px 10px",
                borderRadius: 999,
                background: n ? "#D1FAE5" : "#FEF3C7",
                color: n ? "#065F46" : "#92400E",
              }}
            >
              {p.label}: {n ? `${n} ${n === 1 ? "person" : "people"}` : "nobody yet"}
            </span>
          );
        })}
      </div>
      {missing.length ? (
        <div style={{ fontSize: 13, color: "#92400E", marginTop: 8 }}>
          Nobody holds {missing.map((p) => p.label).join(", ")}. Until someone does, only the owner and admins can do that work, and approvals for it wait on them. Use "Give a permission" to add at least one employee to each.
        </div>
      ) : null}
    </div>
  );
}

// Counts the people per permission from a grants list; skips grants whose employee has left. One
// grant is one person (an employee holds a permission once), so rows are counted, never ids
// (ids are re-encrypted in every row).
export function countHolders(grants) {
  const n = {};
  for (const g of grants || []) {
    if (g.employee_status === "SEPARATED") continue;
    n[g.permission] = (n[g.permission] || 0) + 1;
  }
  return n;
}
